<template>
    <el-row :gutter="30"  class="mw-100 manage-department" >
        
        <el-col :lg="24" :xs="24">
            
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentDepartmentRef"
                    :model="currentDepartmentData"
                    :rules="currentDepartmentDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageDepartment('addDepartmentRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentDepartmentData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addDepartmentRef"
                            :model="currentDepartmentData"
                            :rules="currentDepartmentDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentDepartmentData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddDepartment:true,
            currentDepartment:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentDepartmentData:{},
            currentDepartmentDataRules:{
                value:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title']),
            }
        };
    },
    computed:{
        cachedDepartment(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.careers?.departments.currentDepartment || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedDepartment.id) {
            this.isAddDepartment = false;
            this.currentDepartmentData = JSON.parse(JSON.stringify(this.cachedDepartment))
            this.currentDepartmentData.translates = this.$filterPublishedTranslates(this.currentDepartmentData.translates)
        }else{
            this.$router.push({
                name:'manage-department',
            })
           
            this.isAddDepartment = true;
            this.currentDepartmentData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                translates:this.$setTranslateKeys({
                    'title':''
                })
            }
        },
       
        async manageDepartment(formName){
            let successForm = [];
            this.$refs['addParentDepartmentRef'].validate(async (parentValid) => {
                if (parentValid) {
                    for (let index = 0; index < this.$refs[formName].length; index++) {
                        const element = this.$refs[formName][index];
                        element.validate(async (valid) => {
                            if (!valid) {
                                this.$message({
                                    message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                                    type:'info',
                                    duration:5000,
                                    showClose: true,
                                });
                            }
                        }).then(data =>{
                            let indexOfIndex = successForm.indexOf(index);
                            if (data){
                                successForm.push(index);
                                if (successForm.length == this.$refs['addDepartmentRef'].length){
                                    this.manageDepartmentAfterValidate()
                                }
                            }else{
                                if(indexOfIndex != -1) {
                                    successForm.splice(indexOfIndex,1);
                                }
                            }
                        })  
                    }
                }else{
                    return false
                }
            })
        },
        async manageDepartmentAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddDepartment ? 'addDepartment':'updateDepartment',this.currentDepartmentData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllDepartments');
                this.$router.push({
                    name:'departments-list'
                })
            }
        },
         
    }
}
</script>
<style lang="scss">
    .manage-department {
        .ck-editor {
            width:100%;
        }
    }
</style>